import AppContentView from 'Components/Generic/AppContentView';
import { SITE_PAGES } from 'Config';
import UserData from 'Data/UserData';
import DataManager from 'Lib/DataManager';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import AdminLanding from '../AdminLanding';
import UserDetails from './UserDetails';

let DM = new DataManager();

const UserDetailsPage = ({ userId, userObject, params, isMyAccountPage }) => {
  const navigate = useNavigate();
  let breadcrumbs = params?.id && [
    SITE_PAGES.MANAGE_USERS,
    {
      icon: 'user',
      text: params.id,
    },
  ];

  useEffect(() => {
    DM.add(
      UserData.registerListener('RECORDS_DELETED', () =>
        navigate(SITE_PAGES.MANAGE_USERS.to),
      ),
      UserData,
    );
    return () => {
      DM.clear();
    };
  }, []);

  return isMyAccountPage ? (
    <AppContentView title='My Profile' hideBreadcrumbs>
      <UserDetails isMyAccountPage editable />
    </AppContentView>
  ) : (
    <AdminLanding title='Manage User' breadcrumbs={breadcrumbs}>
      <UserDetails
        params={params}
        userId={userId}
        userObject={userObject}
        editable
      />
    </AdminLanding>
  );
};

UserDetailsPage.propTypes = {
  userId: PropTypes.number,
  userObject: PropTypes.object,
  params: PropTypes.shape({ id: PropTypes.string }),
  isMyAccountPage: PropTypes.bool,
};

export default UserDetailsPage;
